import { Box, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { DsAppBar, DsText, size } from "@mvp/design-system";
import React from "react";
import config from "../config";
import Icons from "../utils/icons";
import { PhoneNumber } from "./PhoneNumber";
import { useTranslation } from "react-i18next";
import { phoneNumbers} from '../store/constants';

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    right: "0",
    top: "2rem",
    position: "fixed",
    zIndex: 1000000,
    display: "flex",
    gap: size.xxs(theme),
    marginRight: "12.5rem",
    [theme.breakpoints.between("md", "lg")]: {
      marginRight: "3.25rem",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: size.m(theme),
    },
  },
  rightSideTitle: {
    color: "rgba(0, 0, 0, 0.6)",
  },
  fontRegular: {
    fontWeight: 600,
  },
}));

export const Header = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const appBarText = !isMobile ? t("header.title") : ""

  const onClickLogo = () => {
    window.location.href = config.HOME_PAGE_URL
  }

  // Add keyboard accessibility to the logo.
  // This allows users to navigate to the logo using the keyboard and activate it with Enter or Space.
  React.useEffect(() => {
    const logoElement = document.getElementById("logoId");
    if (logoElement) {
      logoElement.tabIndex = 0;
      logoElement.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          onClickLogo();
        }
      });
    }
  }, []);

  return (
    <>
      <DsAppBar
        text={appBarText}
        logo={{
          src: Icons.MvpLogo,
          alt: "MVP Logo",
          id: "logoId",
          tabIndex: 0,
          onClick: () => {
            onClickLogo()
          },
        }}
      />
      <Box className={classes.headerContainer}>
        {!isMobile &&
          <DsText variant="body2" className={classes.rightSideTitle} text={t("header.speakWith")} />
        }
        <PhoneNumber color="primary" variant="body2" phoneNumber={phoneNumbers.talkMVP} />
      </Box>
    </>
  );
};